import PropTypes from 'prop-types';
import { formatRetainedDestination } from '../helpers';
import CheckoutFormSection from './CheckoutFormSection';

function deliveryMethodLabel(deliveryMethod) {
  if (deliveryMethod === 'express') {
    return 'Express Delivery';
  }

  if (deliveryMethod === 'standard') {
    return 'Standard Delivery';
  }

  return deliveryMethod;
}

function CheckoutFormRetainedDetails({
  addressDeliveryLocked,
  retainedAttempt,
}) {
  const destination = formatRetainedDestination(
    retainedAttempt.shippingAddress,
  );

  return (
    <CheckoutFormSection title="Retained checkout" first>
      <div className="sm:col-span-6">
        <p className="font-medium text-gray-900 text-sm">
          Payment attempt retained
        </p>
        <p className="mt-1 text-gray-600 text-sm">
          Payment and cart changes are locked so this checkout can finish
          without creating another charge.
        </p>
      </div>
      {addressDeliveryLocked ? (
        <>
          <div className="sm:col-span-6">
            <p className="font-medium text-gray-900 text-sm">
              Retained shipping destination
            </p>
            <p className="mt-1 text-gray-600 text-sm">
              {destination || 'The retained destination could not be loaded.'}
            </p>
          </div>
          <div className="sm:col-span-6">
            <p className="font-medium text-gray-900 text-sm">
              Retained delivery method
            </p>
            <p className="mt-1 text-gray-600 text-sm">
              {deliveryMethodLabel(retainedAttempt.deliveryMethod) ||
                'The retained delivery method could not be loaded.'}
            </p>
          </div>
        </>
      ) : (
        <div className="sm:col-span-6">
          <p className="text-gray-600 text-sm">
            This is a legacy checkout recovery. Confirm the shipping destination
            and delivery method below; those values will be locked when recovery
            starts.
          </p>
        </div>
      )}
    </CheckoutFormSection>
  );
}

CheckoutFormRetainedDetails.propTypes = {
  addressDeliveryLocked: PropTypes.bool.isRequired,
  retainedAttempt: PropTypes.shape({
    deliveryMethod: PropTypes.string,
    shippingAddress: PropTypes.shape({
      address: PropTypes.string,
      address2: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string,
      postalCode: PropTypes.string,
      region: PropTypes.string,
    }),
  }).isRequired,
};

export default CheckoutFormRetainedDetails;
